import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaCalendarAlt, FaUsers, FaChartBar } from "react-icons/fa";

function Sidebar() {
  const location = useLocation();

  const getActiveStyle = (path) => 
    location.pathname === path ? { ...linkStyle, background: "#4318FF" } : linkStyle;

  return (
    <div style={sidebarStyle}>
      <div style={{ padding: "10px", marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", fontWeight: "800", letterSpacing: "1px" }}>GD SYSTEM</h2>
      </div>
      
      <Link to="/dashboard" style={getActiveStyle("/dashboard")}>
        <FaHome /> Dashboard
      </Link>
      <Link to="/bookslot" style={getActiveStyle("/bookslot")}>
        <FaCalendarAlt /> Book Slot
      </Link>
      <Link to="/gdroom" style={getActiveStyle("/gdroom")}>
        <FaUsers /> GD Room
      </Link>
      <Link to="/result" style={getActiveStyle("/result")}>
        <FaChartBar /> Results
      </Link>
    </div>
  );
}

const sidebarStyle = {
  width: "250px", // Fixed Width [cite: 72]
  height: "100vh",
  background: "#111827", // Updated to solid professional dark [cite: 74]
  color: "white",
  padding: "30px 20px",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 1100,
  boxShadow: "4px 0px 10px rgba(0,0,0,0.1)"
};

const linkStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  color: "#A3AED0",
  textDecoration: "none",
  padding: "15px",
  marginBottom: "8px",
  borderRadius: "12px",
  fontSize: "15px",
  fontWeight: "600",
  transition: "0.3s all ease"
};

export default Sidebar;